import { render, staticRenderFns } from "./PlansAndCoupon.vue?vue&type=template&id=561c153c&scoped=true&"
import script from "./PlansAndCoupon.vue?vue&type=script&lang=js&"
export * from "./PlansAndCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561c153c",
  null
  
)

export default component.exports